module.exports = __webpack_public_path__ + "static/media/Alex_Che_-_Inspiring_Epic_Trailer.7ed9f961.mp3";